import { ActivatedRoute, Router } from '@angular/router';
import { ApprovalDetailsConstants } from 'src/app/core/constants/approval-details.constants';
import {
  ApprovalMMDActionDetail,
  ApprovalSAActionDetail,
} from '../../../models/approval-details/action-detail.model';
import { BulkActionComponent } from 'src/app/core/components/bulk-action/bulk-action.component';
import { ChangeDataActionResponseDto } from '../../../models/change-sar/change-data-action-response.model';
import { ChangeDataApprovalExcelColumn } from 'src/app/core/constants/excel-columns-const';
import { ChangeDataConst } from 'src/app/core/constants/change-data.const';
import { ChangeDataItem } from '../../../models/change-sar/change-data-item.model';
import { ChangeDataService } from '../../../services/change-data.service';
import { CommonService } from 'src/app/core/services/common.service';
import { Component, EventEmitter, Input, Output } from '@angular/core';
import { DialogRef, DialogService } from '@progress/kendo-angular-dialog';
import { NewActionInputParam } from '../../../models/common/new-action-input-param.model';
import { SelectionEvent } from '@progress/kendo-angular-grid';
import { ConsultNewActionDto } from '../../../models/add-new-action/consult-new-action.model';
import { AddNewActionService } from '../../../services/add-new-action.service';
import { Location } from '@angular/common';
import { SmeReviewPopupComponent } from '../sme-review-popup/sme-review-popup.component';
import { ConsultAssignmentPopupComponent } from '../consult-assignment-popup/consult-assignment-popup.component';
import { SarUsersService } from 'src/app/features/setup/services/sar-users.service';
import { forkJoin } from 'rxjs';
import { SARUsers } from 'src/app/features/setup/models/sarusers/sarusers.model';

@Component({
    selector: 'app-change-data-approval',
    templateUrl: './change-data-approval.component.html',
    styleUrls: ['./change-data-approval.component.scss'],
    standalone: false
})
export class ChangeDataApprovalComponent {
  @Input() public requiredParams: NewActionInputParam = {};
  @Input() public currentActionName: string = '';
  @Input() public dummyInput: number = 0;
  @Input() public isABU: boolean;
  changeDataDetails: ChangeDataActionResponseDto =
    new ChangeDataActionResponseDto();

  @Input() public isAdminRole: boolean;

  @Output() saActionEvent = new EventEmitter<ApprovalSAActionDetail>();
  @Output() mmdActionEvent = new EventEmitter<ApprovalMMDActionDetail>();
  @Output() mmdBulkActionEvent = new EventEmitter<ApprovalMMDActionDetail[]>();
  @Output() saBulkActionEvent = new EventEmitter<ApprovalSAActionDetail[]>();
  mySelection: number[] = [];
  changeDataApprovalExcelColumn: any = ChangeDataApprovalExcelColumn;
  isBulk = true;

  isSMEReviewAction: boolean = false;
  requestIssueId: number = 0;
  public consultAction: ConsultNewActionDto = { GroupId: -1 };

  buName: string = '';

  constructor(
    public router: Router,
    private route: ActivatedRoute,
    private changeDataService: ChangeDataService,
    private dialogService: DialogService,
    public commonService: CommonService,
    private addNewActionService: AddNewActionService,
    private location: Location,
    private userService: SarUsersService
  ) { }

  // eslint-disable-next-line @angular-eslint/use-lifecycle-interface
  ngOnChanges() {
    this.buName = this.commonService.getUserBUName();
    this.requestIssueId = this.requiredParams.requestIssueId!;
    this.getChangeData();
  }

  openPopup() {
    if (this.currentActionName === 'sme-action') {
      let requestLineIds = [];
      for (let selectedValue of this.mySelection) {
        let dataItem =
          this.changeDataDetails!.items[selectedValue];
        requestLineIds.push(dataItem.requestLineId);
      }
      let consultAction: ConsultNewActionDto = { GroupId: -1 };
      consultAction.RequestLineIds = requestLineIds;
      consultAction.RequestId = this.requiredParams.requestId;
      consultAction.RequestIssueTypeId = 2;
      consultAction.RequestIssueId = this.requiredParams.requestIssueId!;
      this.showSMEReviewPopup(consultAction, true);
    } else {
      const dialog: DialogRef = this.dialogService.open({
        content: BulkActionComponent,
      });
      const inc = dialog.content.instance as BulkActionComponent;
      inc.isMMD = this.currentActionName === 'mmd-action' ? true : false;
      inc.isABUUnit = this.isABU;
      dialog.result.subscribe((r: any) => {
        if (
          this.commonService.isNullOrEmpty(r.action) ||
          r.action === 'Close'
        ) {
          return false;
        }
        this.bulkAction(r.action, r.comment, r.lineItemDtail);
      });
    }
  }

  bulkAction(actionType: string, comment: string, lineItemDtail: any) {
    if (actionType === 'Consult') {
      let consultAction = lineItemDtail;
      this.bulkConsult(this.mySelection, comment, consultAction);
    } else {
      if (this.currentActionName === 'mmd-action') {
        let approvalMMDActionDetail: ApprovalMMDActionDetail[] = [];
        for (let selectedValue of this.mySelection) {
          let dataItem = this.changeDataDetails.items[selectedValue];
          if (dataItem.status !== 'Pending MMD') {
            continue;
          }
          dataItem.comment = comment;
          let approvalActionDetail = this.getmmdValues(dataItem);
          if (actionType === 'Cancel') {
            approvalActionDetail.mmdAction = 3;
          }
          if (actionType === 'Reject') {
            approvalActionDetail.mmdAction = 1;
          }
          if (actionType === 'Complete') {
            approvalActionDetail.mmdAction = 2;
          }
          approvalMMDActionDetail.push(approvalActionDetail);
        }
        this.mySelection = [];
        this.mmdBulkActionEvent.emit(approvalMMDActionDetail);
      }
      if (this.currentActionName === 'sa-action') {
        let approvalSAActionDetail: ApprovalSAActionDetail[] = [];
        for (let selectedValue of this.mySelection) {
          let dataItem = this.changeDataDetails.items[selectedValue];
          if (dataItem.status !== 'PendingStockingApproval') {
            continue;
          }
          dataItem.comment = comment;
          let approvalActionDetail = this.getsaValues(dataItem);
          if (actionType === 'Cancel') {
            approvalActionDetail.stockApproverAction = 3;
          }
          if (actionType === 'Reject') {
            approvalActionDetail.stockApproverAction = 1;
          }
          if (actionType === 'Complete') {
            approvalActionDetail.stockApproverAction = 2;
          }
          approvalSAActionDetail.push(approvalActionDetail);
        }
        this.mySelection = [];
        this.saBulkActionEvent.emit(approvalSAActionDetail);
      }
    }
  }

  bulkConsult(
    mySelection: number[],
    comment: string,
    consultAction: ConsultNewActionDto
  ) {
    let requestLineIds = [];
    for (let selectedValue of mySelection) {
      let dataItem = this.changeDataDetails.items[selectedValue];
      requestLineIds.push(dataItem.requestLineId);
    }

    if (requestLineIds !== undefined && requestLineIds.length > 0) {
      consultAction.RequestLineIds = requestLineIds;
      consultAction.UserEmailId = this.commonService.getUserEmailId();
      consultAction.RequestId = this.requiredParams.requestId;
      consultAction.Comment = comment;
      consultAction.RequestIssueId = this.requiredParams.requestIssueId!;

      this.addNewActionService
        .updateOnBulkConsultAction(consultAction)
        .subscribe(() => {
          this.location.back();
        });
    }
  }

  clickCheckBox(e: SelectionEvent) {
    this.isBulk = true;
    for (let selected of this.mySelection) {
      if (
        this.changeDataDetails.items[selected].status === 'Pending MMD' ||
        this.changeDataDetails.items[selected].status ===
        ApprovalDetailsConstants.PendingStockingApproval ||
        this.changeDataDetails.items[selected].status === 'Pending SME Review'
      ) {
        this.isBulk = false;
        break;
      }
    }
  }

  getChangeData() {
    let userDetails = this.userService
      .GetAllUserDetailsByEmail(this.commonService.getUserEmailId());

    let req2 = this.changeDataService
      .getChangeDataDetail(
        this.requiredParams.requestId!,
        this.requiredParams.requestIssueId!
      );

    forkJoin(userDetails, req2)
      .subscribe((response) => {
        let userDetails = response[0] as SARUsers;
        let outputDtata = response[1] as ChangeDataActionResponseDto;
        if (outputDtata) {
          outputDtata.items = outputDtata.items.filter(
            (x) => x.status !== 'Draft'
          );
          if (this.currentActionName === 'sa-action') {
            this.changeDataDetails = new ChangeDataActionResponseDto();
            return false;
          }
          this.changeDataDetails = outputDtata;
          this.mySelection = [];
          if (this.currentActionName !== 'summary' && this.currentActionName !== 'sme-action') {
            this.changeDataDetails.items = this.changeDataDetails.items.filter(
              (x) => x.status !== 'Rejected' && x.status != 'Cancelled' && x.status != 'Pending SME Review'
            );
          }
          if (this.currentActionName === 'sme-action') {
            let currentUserId = userDetails.id;
            let userGroups = userDetails.groupDtos?.map((group) =>
              group.id
            );
            this.isSMEReviewAction = true;
            this.changeDataDetails.items = this.changeDataDetails.items.filter(
              (x) => x.status === 'Pending SME Review' && (this.isAdminRole || x.assignedUser === currentUserId || userGroups?.includes(x.assignedGroup))
            );
          }
        }
      });
  }

  assignEmpty(dataItem: any) {
    dataItem.comment = dataItem.comment == undefined ? '' : dataItem.comment;
  }

  cancel(dataItem: ChangeDataItem) {
    dataItem.isCommentError = false;
    if (this.commonService.isNullOrEmpty(dataItem.comment!)) {
      dataItem.isCommentError = true;
      this.commonService.showNotificationMessage(
        ChangeDataConst.globalErrorMessage,
        'error',
        'right'
      );
      return false;
    }
    this.commonService
      .showConfirmation(
        'Cancel',
        ApprovalDetailsConstants.cancelledMessage,
        true
      )
      .subscribe((res: any) => {
        if (res.action === 'yes') {
          this.mySelection = [];
          let approvalActionDetail = this.getmmdValues(dataItem);
          approvalActionDetail.mmdAction = 3;
          this.mmdActionEvent.emit(approvalActionDetail);
        }
      });
  }

  reject(dataItem: ChangeDataItem) {
    dataItem.isCommentError = false;
    if (this.commonService.isNullOrEmpty(dataItem.comment!)) {
      dataItem.isCommentError = true;
      this.commonService.showNotificationMessage(
        ChangeDataConst.globalErrorMessage,
        'error',
        'right'
      );
      return false;
    }
    this.commonService
      .showConfirmation('Rejection', ApprovalDetailsConstants.rejectMessage)
      .subscribe((res: any) => {
        if (res.action === 'yes') {
          this.mySelection = [];
          let approvalActionDetail = this.getmmdValues(dataItem);
          approvalActionDetail.mmdAction = 1;
          this.mmdActionEvent.emit(approvalActionDetail);
        }
      });
  }

  complete(dataItem: ChangeDataItem) {
    if (this.currentActionName === 'mmd-action') {
      this.commonService
        .showConfirmation('Complete', ApprovalDetailsConstants.completeMessage)
        .subscribe((res: any) => {
          if (res.action === 'yes') {
            this.mySelection = [];
            let approvalActionDetail = this.getmmdValues(dataItem);
            approvalActionDetail.mmdAction = 2;
            this.mmdActionEvent.emit(approvalActionDetail);
          }
        });
    }
  }

  getmmdValues(dataItem: ChangeDataItem): ApprovalMMDActionDetail {
    let approvalMMDActionDetail: ApprovalMMDActionDetail =
      new ApprovalMMDActionDetail();
    approvalMMDActionDetail.comment = dataItem.comment;
    approvalMMDActionDetail.createdBy = this.commonService.getUserEmailId();
    approvalMMDActionDetail.enrichedDescription = '';
    approvalMMDActionDetail.materialNumber = '';
    approvalMMDActionDetail.shortDescription = '';
    approvalMMDActionDetail.modifiedBy = this.commonService.getUserEmailId();
    approvalMMDActionDetail.requestIssueId =
      this.requiredParams.requestIssueId!;
    approvalMMDActionDetail.requestIssueTypeId = 2;
    approvalMMDActionDetail.requestLineId = dataItem.id;
    approvalMMDActionDetail.requestId = this.requiredParams.requestId!;
    return approvalMMDActionDetail;
  }

  getsaValues(dataItem: ChangeDataItem): ApprovalSAActionDetail {
    let approvalMMDActionDetail: ApprovalSAActionDetail =
      new ApprovalSAActionDetail();
    approvalMMDActionDetail.comment = dataItem.comment;
    approvalMMDActionDetail.createdBy = this.commonService.getUserEmailId();
    approvalMMDActionDetail.modifiedBy = this.commonService.getUserEmailId();
    approvalMMDActionDetail.requestIssueId =
      this.requiredParams.requestIssueId!;
    approvalMMDActionDetail.requestIssueTypeId = 2;
    approvalMMDActionDetail.requestLineId = dataItem.id;
    approvalMMDActionDetail.requestId = this.requiredParams.requestId!;
    return approvalMMDActionDetail;
  }

  public exportToExcel() {
    let date = new Date().toISOString();
    date = date
      .substring(0, date.lastIndexOf(':'))
      .replace('T', '-')
      .replace(':', '-');
    let fileName =
      this.requiredParams.requestNumber +
      '-Action-' +
      this.requiredParams.actionNumber +
      '-' +
      'Item-Export-' +
      date;
    this.commonService.exportAsExcelFile(
      this.changeDataDetails!.items,
      this.changeDataApprovalExcelColumn,
      fileName
    );
  }

  addSMEReview(dataItem: ChangeDataItem) {
    let consultAction: ConsultNewActionDto = { GroupId: -1 };
    consultAction.Id = dataItem.id;
    consultAction.RequestLineId = dataItem.requestLineId;
    consultAction.Status = dataItem.status;
    consultAction.RequestId = this.requiredParams.requestId;
    consultAction.RequestIssueId = this.requiredParams.requestIssueId!;
    this.showSMEReviewPopup(consultAction, false);
  }

  showSMEReviewPopup(
    consultAction: ConsultNewActionDto,
    isBulkAction: boolean
  ) {
    const dialog: DialogRef = this.dialogService.open({
      content: SmeReviewPopupComponent,
    });
    const inc = dialog.content.instance as SmeReviewPopupComponent;
    inc.isBulkAction = isBulkAction;
    dialog.result.subscribe((r: any) => {
      if (this.commonService.isNullOrEmpty(r.actionType) || r.actionType === 'close') {
        return false;
      }
      if (
        !this.commonService.isNullOrEmpty(r.actionType) &&
        r.actionType === 'submit'
      ) {
        consultAction.UserEmailId = this.commonService.getUserEmailId();
        consultAction.Comment = r.comment;
        consultAction.RequestIssueTypeId = 2;

        if (r.bulkAction) {
          this.addNewActionService
            .addBulkSMEReviewOnConsultAction(consultAction)
            .subscribe(() => {
              this.location.back();
            });
        } else {
          this.addNewActionService
            .addSMEReviewOnConsultAction(consultAction)
            .subscribe(() => {
              this.location.back();
            });
        }
      }
    });
  }

  consult(dataItem: ChangeDataItem) {
    this.consultAction.Id = dataItem.id;
    this.consultAction.RequestLineId = dataItem.requestLineId;
    this.consultAction.Status = dataItem.status;
    this.consultAction.Comment = dataItem.comment;

    const dialog: DialogRef = this.dialogService.open({
      content: ConsultAssignmentPopupComponent
    });
    dialog.result.subscribe((r: any) => {
      if (r.actionType == 'submit') {
        this.consultAction.GroupId = r.lineItemDtail!.GroupId;
        this.consultAction.UserGroupId = r.lineItemDtail!.UserGroupId;
        this.consultAction.UserEmailId = this.commonService.getUserEmailId();
        this.consultAction.RequestId = this.requiredParams.requestId;
        this.consultAction.Comment = r.comment;
        this.consultAction.RequestIssueTypeId = 2;
        this.consultAction.RequestIssueId = this.requiredParams.requestIssueId!;

        this.addNewActionService
          .updateOnConsultAction(this.consultAction)
          .subscribe(() => {
            this.location.back();
          });
      }
    });

  }

}
